/**
 *
 * 文本高亮
 *
 * */
function removeScript (context) {
  // 防止脚本攻击
  context = context.replace(/<script/g, '*script')
  return context.replace(/<\/script/g, '*script')
}

// function addBlank (context) {
//   // nbsp 空格替换
//   context = context.replace(/\s/g,
//     `&nbsp;`)
//   return context
// }

// Vue文本高亮
function highlightText (el, binding, setting) {
  let context = binding.value[0]
  let lightText = binding.value[1]
  let className = binding.value[2]
  // context = addBlank(context)

  // if (lightText === '' || !lightText) {
  //   return removeScript(context)
  // }
  //
  // let lightRegExp = new RegExp(lightText, 'g')
  if (className) {
    context = context.replace(lightText,
      `<span class="${className}">${lightText}</span>`)
  } else {
    context = context.replace(lightText,
      `<span class="${setting.defaultClass}">${lightText}</span>`)
  }
  return removeScript(context)
}

export const VueHighLight = (Vue, setting) => {
  if (!setting) {
    setting = {}
  }
  if (setting.defaultClass) {
    setting.defaultClass = 'default-class'
  }
  return {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el, binding) {
      el.innerHTML = highlightText(el, binding, setting)
    },
    update: function (el, binding) {
      el.innerHTML = highlightText(el, binding, setting)
    }
  }
}
